export const getCountryPhoneNumberFormat = (countryCode: string): string => {
    switch (countryCode) {
        case "US":
            return "(000) 000-0000";
            case "CA":
            return "(000) 000-0000";
        case "GB":
            return "0000 000 0000";
        case "FR":
            return "00 00 00 00 00";
        case "ZW":
            return "(000) 000-000";
        // Add more cases for other countries as needed
        default:
            return "000-000-0000";
    }
};